module.exports = __webpack_public_path__ + "static/media/thumbnail-hospedagem.1e2578fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/thumbnail-hospedagem.png
// module id = 398
// module chunks = 0